import React, { Component } from "react";
import {
	Card,
	CardTitle,
	Row,
	Col,
	CardBody
} from "reactstrap";
import { Line } from "react-chartjs-2";

import Registry from "../../../Utils/Registry";
import Utils from "../../../Utils/Helpers";



export default class AnalyticsChartConsumption100 extends Component{
	constructor(props){
		super(props);

		this.state = {
			raw_data: {},
			data: null,
			selected_index: null
		};

		this.api = Registry.registered("api");
	}

	componentDidMount(){
		this.loadData();
	}

	loadData = () => {
		this.api.get("/stats/fleet/consumption/100")
			.then(results => {
				this.setState({raw_data: results}, () => {
					if(this.state.raw_data.length)
						this.selectVehicle(this.state.raw_data[0]);
				});
			});
	};

	_selectUpdated = e => {
		this.selectVehicle(this.state.raw_data[e.target.value], e.target.value);
	};

	selectVehicle(data, index=0){
		let dates = [];
		let values = [];
		let plate = data.vehicle.plate;

		for(let c of data.consumptions){
			dates.unshift(Utils.formatDate(c.date, "DD/MM/YYYY"));
			values.unshift(c.conso.toFixed(2));
		}

		this.setState({
			selected_index: index,
			data: {
				labels: dates,
				datasets: [{
					label: plate,
					fill: false,
					borderColor: "#e60063",
					data: values
				}]
			}
		})
	}

	render(){
		if(!this.state.data)
			return null;
		return <Card className="">
			<CardBody className="card-body pb-0">
				<Row>
					<Col xs="7" sm="7" lg="6" className="pad-xs-r-0">
						<CardTitle className="mb-0 ty-subtitle d-inline-block">
							Consommation flotte aux 100Km
						</CardTitle>
						<i className={"icon-question pad-5 tooltip-info"} aria-hidden="true">
							<span className="tooltip-info-text">
								Estimations basées uniquement sur les ravitaillements réalisées par Tankyou.
							</span>
						</i>
					</Col>
					<Col xs="5" sm="5" lg="6" className="pad-xs-l-0">
					</Col>
				</Row>
				<Row className="marg-t-20">
					<Col md="6">
						<div>
							<select className="form-control" value={this.state.selected_index} onChange={ this._selectUpdated }>
								<option value="">vehicule ...</option>
								{
									this.state.raw_data.map((d, i) => {
										return <option
											key={"veh-conso-"+i}
											value={i}
										>
											{d.vehicle.description} - {d.vehicle.plate}
										</option>;
									})
								}
							</select>
						</div>

						<div style={{marginTop: 20}}>
							<ul>
							{
								this.state.selected_index !== null && this.state.raw_data[this.state.selected_index] ?
									this.state.raw_data[this.state.selected_index].refuelling.map((d, i) => {
										return <li key={"li-conso-"+i}>
											le <b>{ Utils.formatDate(d.ending_datetime) }</b> ravitaillement de&nbsp;
											<b>{ d.quantity_delivered.toFixed(2) }</b> { d.gas_unit } et un compteur kilometrique &agrave;&nbsp;
											<b>{ d.km.toFixed(2) }</b> Km : <b>{this.state.raw_data[this.state.selected_index].consumptions[i].conso.toFixed(2)}</b> { d.gas_unit } / 100
										</li>;
									})
									:
									null
							}
							</ul>
						</div>
					</Col>
					<Col md="6">
						<div className="chart-wrapper marg-b-20">
							<Line data={this.state.data} options={this.props.options} height={Utils.isMobile() ? "200rem" : null}/>
						</div>
					</Col>
				</Row>
			</CardBody>
		</Card>;
	}
}


AnalyticsChartConsumption100.defaultProps = {
	options: {
		legend: {
			display: false
		},
		scales: {
			yAxes: [{
				ticks: {
					beginAtZero: true
				}
			}]
		}
	}
};




// WEBPACK FOOTER //
// ./src/components/Analytics/Charts/Consumption100.js